import React from "react";
import type { ApiClient } from "../../app/api/client";
import { usePhotoObjectUrls, type PhotoIdentity } from "../../app/utils/usePhotoObjectUrls";

type PersonPhotoIdentity = {
  id?: string | null;
  hasPhoto?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export function usePersonPhotoObjectUrls(api: ApiClient, persons: PersonPhotoIdentity[]): Record<string, string> {
  const subjects = React.useMemo<PhotoIdentity[]>(() => persons.flatMap(person =>
    person.hasPhoto && person.id ? [{ id: person.id, kind: "persons", version: String(person.updatedAt || person.createdAt || "") }] : []), [persons]);
  return usePhotoObjectUrls(api, subjects);
}
